import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CheckTokenActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class CheckTokenEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getCheckToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckTokenActions.getCheckToken),
      switchMap((action) =>
        this.onboardingProductsService.getCheckToken(action.request).pipe(
          map((res) => this.responseInterpreter(res)),
          map((res) => res['data']),
          map((res) =>
            CheckTokenActions.getCheckTokenSuccess({ response: res })
          ),
          catchError((error) =>
            of(
              CheckTokenActions.getCheckTokenError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );

  responseInterpreter(res) {
    console.log('******** ResponseInterpreter Input', res);
    const response = res;

    if (
      _.get(res, 'status', '') === 200 ||
      _.get(res, 'status', '') === 201
    ) {
      if (_.get(res, 'data', null)) {
        response['data'] = _.get(res, 'data', null);
      }
      if (_.get(res, 'payload', null)) {
        response['data'] = _.get(res, 'payload', null);
      }
    }
    response['data'] = {code: res.client.operationState.code, message: res.client.operationState.message};
    console.log('******** ResponseInterpreter Return', response);
    return response;
  }
}
